<script>
    // -- IMPORTS
    
	import TextForm from './../../../../../ADMIN/src/lib/component/form/TextForm.svelte';
    import Modal from "../../../../../ADMIN/src/lib/component/element/Modal.svelte";
    import { languageTagStore } from '$src/lib/store/languageTagStore';
    
    // -- VARIABLES

    /** @type {{isModalOpen?: boolean, textData?: any, isMultiline?: boolean, handleReloadText?: any}} */
    let {
        isModalOpen = $bindable(false),
        textData = {},
        isMultiline = true,
        handleReloadText = () => {}
    } = $props();
</script>

<Modal
    bind:showModal={ isModalOpen }
    modalConfirmButtonLabel="Save"
    modalType=""
    hasFooterButtons={ false }
    modalTitle={ `Edit ${ textData.slug }` }
>
    <TextForm
        isMultiline={ isMultiline }
        activeLanguageCode={ $languageTagStore }
        textData={ textData }
        isInsideModal={ true }
        onUpdateText={ handleReloadText }
    />
</Modal>